import noDataFoundMessage from "./noDataFoundMessage";

export default noDataFoundMessage;
